import React from "react";
import {Link} from "react-router-dom";

type SidebarFirstLevelMenuItemProps = {
    value: string;
    path: string;
};

const SidebarFirstLevelMenuItem: React.FC<SidebarFirstLevelMenuItemProps> = ({value, path}) => {
    return (
        <Link to={path} onClick={() => {
            // localStorage.setItem("focus", value.toLowerCase())
        }}
              className={localStorage.getItem("focus") === value.toLowerCase() ?
                  "px-4 py-2 rounded bg-blue-700" :
                  "px-4 py-2 rounded hover:bg-blue-700"}>
            {value}
        </Link>
    )
}

export default SidebarFirstLevelMenuItem;